import { render, staticRenderFns } from "./Pop_up_redirect_online.vue?vue&type=template&id=8d8c3030&scoped=true&"
import script from "./Pop_up_redirect_online.vue?vue&type=script&lang=js&"
export * from "./Pop_up_redirect_online.vue?vue&type=script&lang=js&"
import style0 from "./Pop_up_redirect_online.vue?vue&type=style&index=0&id=8d8c3030&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8c3030",
  null
  
)

export default component.exports